import { Injectable } from '@angular/core';
import { UserService } from '../user-service/userservice';
import { OrganisationService } from '../dataServices/organisation-service/organisationservice';
import { HttpClient } from '@angular/common/http';
import { API_BASE_USERSERVICE } from 'src/environments/api';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    getLocalStorageItem,
    setLocalStorageItem
} from 'src/app/utils/browser-storage';

@Injectable({
    providedIn: 'root'
})
export class StartUpService {
    constructor(
        private http: HttpClient,
        private userService: UserService,
        private organisationService: OrganisationService
    ) { }

    async handleLogin() {
        return this.configureUserService().then((x) => {
            if (x || this.userService.loggedIn) {
                this.organisationService.loadOrganisationsForUser();
            }
        });
    }

    async configureUserService(): Promise<boolean> {
        const isLoggedIn = await this.isUserLoggedIn();
        if (isLoggedIn) {
            try {
                const id = await this.checkUserCredentials();

                // set userId in userService
                this.userService.currentUser.userId = id;
                this.userService.loggedIn = true;
                this.userService.fetchCurrentUser();

                await this.userService.updateAuthorisation();
                return true;
            } catch (err) {
                // credentials declined
                await this.loginAnonymous();
                return false;
            }
        } else {
            await this.loginAnonymous();
            return false;
        }
    }

    /**
     * Check if the local storage contains a refresh token, which indicates that the
     * user was logged in the last time he accessed the website.
     * @returns true if BFF has an entry for the cookie else false
     */
    async isUserLoggedIn(): Promise<boolean> {
        return await this.http.get<boolean>('/proxy/api/v0/login').pipe(
            map(isLoggedIn => {
                if (isLoggedIn) return true;
                return false;
            }),
            catchError(err => of(false))
        ).toPromise();

        //var hasUserId: boolean =
        //  typeof currentUserId === "undefined" ||
        // currentUserId === null ||
        // currentUserId === 0;
    }

    /**
     * If the user is not logged in set authorisation to anonymous
     */
    async loginAnonymous(): Promise<boolean> {
        var url = API_BASE_USERSERVICE + '/users/login/anonymous';
        return new Promise((resolve, reject) => {
            this.http
                .post<{ access_token: string }>(url, {})
                .subscribe((token) => {
                    let isUserLoggedIn: string = getLocalStorageItem('refresh_token');
                    if (token && !isUserLoggedIn) {
                        setLocalStorageItem(
                            'access_token',
                            token.access_token
                        );
                        //this.userService.currentUser.userName == "Anonymous";
                        this.userService.currentUser.userId = 0;
                        this.userService.loggedIn = false;
                        this.userService.getAnonymousAuthorisation();
                        resolve(true);
                    } else {
                        this.userService.loggedIn = true;
                        this.userService.fetchCurrentUser();
                        resolve(true);
                    }
                }, () => {
                    this.userService.currentUser.userId = 0;
                    this.userService.loggedIn = false;
                    resolve(false);
                });
        });
    }

    /**
     * We check if user ID and access credentials match
     * //TODO
     */
    checkUserCredentials(): Promise<number> {
        return new Promise((resolve, reject) => {
            this.userService.getCurrentUser().subscribe((user) => {
                if (user && user.userId && user.userId !== 0) {
                    this.userService.saveUser(user);
                    resolve(user.userId);
                } else {
                    reject(-1);
                }
            });
        });
    }
}
